import React from 'react';
import profileImage from '../assets/images/profile.jpeg';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-content">
        <div className="contact-text">
          <h1>Contact</h1>
          <div className="contact-info">
            
            <div className="info-item">
              <h3>Booking Inquiries</h3>
              <p>For concert bookings and collaborations:</p>
              <a href="mailto:booking@example.com">sj3984@msmnyc.edu</a>
              <p>Tel: +1 (332)272-8454</p>
            </div>

            <div className="info-item">
              <h3>Media Inquiries</h3>
              <p>For interviews and press materials:</p>
              <a href="mailto:press@example.com">sj3984@msmnyc.edu</a>
              <p>Tel: +1 (332)272-8454</p>
            </div>
          </div>

          <div className="social-links">
            <h3>Social Media</h3>
            <div className="social-icons">
              <a href="https://www.youtube.com/@soohyun_aria/videos" target="_blank" rel="noopener noreferrer">YouTube</a>
              <a href="https://www.instagram.com/soohyun_aria/" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
          </div>
        </div>
        
        <div className="image-container">
          <img src={profileImage} alt="Soohyun Jo" className="profile-image" />
          <div className="image-caption">
            <h2>Soohyun Jo</h2>
            <p>Soprano</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;